import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
require('dayjs/locale/id')
dayjs.locale('id')
dayjs.extend(localizedFormat)

export default {
  methods: {
    currency: (number) => new Intl.NumberFormat(
      'id-ID',
      {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }
    ).format(number),
    integer: (number) => new Intl.NumberFormat(
      'id-ID',
      {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }
    ).format(number),
    readableDate: (date) => dayjs(date).format('D MMMM YYYY'),
    now: () => dayjs().format('YYYY-MM-DD HH:mm'),
  }
}